const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaygroundmin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.406 1C2.653 1.047 2 1.745 2 2.5 2 3.285 2.715 4 3.5 4S5 3.284 5 2.5C5.002 1.682 4.222.949 3.406 1zm8 3C10.653 4.047 10 4.745 10 5.5c0 .785.715 1.5 1.5 1.5S13 6.284 13 5.5c.002-.818-.778-1.551-1.594-1.5zM3 4.5c-1.471 0-1.866 1.873-1.969 2.875L0 7v1l5.969 2.125L5 14h4l-.938-3.125L14 13v-1l-.938-.344C13.227 10.795 13.75 7.5 12 7.5c-1.638 0-1.915 2.245-1.969 3.094L4.094 8.469C4.285 7.338 4.614 4.5 3 4.5z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaygroundmin);
export default __webpack_public_path__ + "static/media/playground.min.97829d9a39e16e0e4c5c2b0f1789c468.svg";
export { ForwardRef as ReactComponent };